import React, { useEffect, useContext } from 'react';
import { ReportContextProvider } from '@nile/reports/src/modules/reports/contexts/Report';
import NewReportGrid from '@nile/reports/src/modules/reports/components/subpages//NewReportGrid';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import {
  DEFAULT_VIEW,
  PDF_REPORT
} from '@nile/reports/src/modules/home/constants';
import { ExportContext } from '@nile/components';
import { isEmpty, isEqual, omit } from 'lodash';
import PDFReportSheet from '@nile/reports/src/modules/reports/components/subpages/PDFReportSheet';
import { Modal } from './styles';

const ReportSheet = (props) => {
  const { isExport, refreshReport, reportType } = props;
  const exportContext = useContext(ExportContext);
  const reportsContext = useContext(ReportsContext);

  const originalData = reportsContext.activeSection.data;
  const data = reportsContext.activeReport;
  const isViewOnly = reportsContext.reportViewMode === 'VIEW';

  useEffect(() => {
    if (originalData) {
      reportsContext.dispatch({
        type: 'updateLayout',
        layout: originalData?.layout || []
      });
    }
  }, [originalData]);

  const providerValue = {
    layout: reportsContext.layout
  };

  useEffect(() => {
    const layoutFromData =
      (!isEmpty(originalData) && originalData.layout) || [];
    const layoutXYPosition = layoutFromData.map((el) => omit(el, ['chart']));
    const originalLayoutXYPosition = reportsContext.layout.map((el) =>
      omit(el, ['chart'])
    );
    if (
      isViewOnly &&
      reportsContext.activeView !== DEFAULT_VIEW &&
      !isEmpty(reportsContext.layout) &&
      !isEqual(layoutXYPosition, originalLayoutXYPosition)
    ) {
      reportsContext.handleReportSave(true, reportsContext.layout);
    }
    if (isExport) {
      exportContext.setIsRendered(true);
    }
  }, [reportsContext.layout]);

  return (
    <Modal
      className="fx full-height"
      isExport={isExport || reportsContext.isTvDashboard}
      disableScroll={reportsContext.isTvDashboard}
    >
      <div className="FormContainer Modal-Wrap full-height">
        <ReportContextProvider value={providerValue}>
          <div
            className={`fx white-grey-page reportSection ${reportType ===
              PDF_REPORT && 'jspard'}`}
          >
            {reportType === PDF_REPORT && (
              <PDFReportSheet data={data} reportType={reportType} />
            )}
            {reportType !== PDF_REPORT && (
              <NewReportGrid
                charts={data?.charts}
                layout={reportsContext.layout}
                dispatch={reportsContext.dispatch}
                isViewOnly={isViewOnly}
                isExport={isExport}
                refreshReport={refreshReport}
                allowDragDrop={
                  (!reportsContext?.isTvDashboard &&
                    !isExport &&
                    !(reportsContext.activeView === DEFAULT_VIEW)) ||
                  (reportsContext.cloneId &&
                    reportsContext.activeView === DEFAULT_VIEW)
                }
              />
            )}
          </div>
        </ReportContextProvider>
      </div>
    </Modal>
  );
};

export default ReportSheet;
